var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.1905H8.66667C9.4 10.1905 10 9.59049 10 8.85716V2.19049H4C3 2.19049 2.12667 2.74382 1.67334 3.55715",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 12.1905C1.33333 13.2972 2.22666 14.1905 3.33333 14.1905H3.99999C3.99999 13.4572 4.59999 12.8572 5.33333 12.8572C6.06666 12.8572 6.66666 13.4572 6.66666 14.1905H9.33333C9.33333 13.4572 9.93333 12.8572 10.6667 12.8572C11.4 12.8572 12 13.4572 12 14.1905H12.6667C13.7733 14.1905 14.6667 13.2972 14.6667 12.1905V10.1905H12.6667C12.3 10.1905 12 9.89049 12 9.52382V7.52382C12 7.15716 12.3 6.85716 12.6667 6.85716H13.5266L12.3867 4.86383C12.1467 4.4505 11.7067 4.19049 11.2267 4.19049H10V8.85716C10 9.59049 9.4 10.1905 8.66666 10.1905H8",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 15.5238C6.06971 15.5238 6.66667 14.9269 6.66667 14.1905C6.66667 13.4541 6.06971 12.8571 5.33333 12.8571C4.59695 12.8571 4 13.4541 4 14.1905C4 14.9269 4.59695 15.5238 5.33333 15.5238Z",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 15.5238C11.403 15.5238 12 14.9269 12 14.1905C12 13.4541 11.403 12.8571 10.6667 12.8571C9.93028 12.8571 9.33333 13.4541 9.33333 14.1905C9.33333 14.9269 9.93028 15.5238 10.6667 15.5238Z",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 8.85715V10.1905H12.6667C12.3 10.1905 12 9.89048 12 9.52381V7.52381C12 7.15715 12.3 6.85715 12.6667 6.85715H13.5267L14.6667 8.85715Z",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 6.19049H5.33333",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 8.19049H3.99999",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 10.1905H2.66666",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.5d17b06e3bfc076736a8d5af263b3815.svg";
export { ForwardRef as ReactComponent };